import Vue from 'vue';
import xpcConfig from '../config';
import Parse from './address';

function goBack () {
  Vue.prototype.$router.go(-1);
}

function logout () {
  rt.showConfirmDialog(
    '',
    Vue.prototype.$tx('确认注销？', 'xpc.common.comfirmLogout'),
    Vue.prototype.$tx('确定', 'xpc.common.ok'),
    Vue.prototype.$tx('取消', 'xpc.common.cancel'),
    'warning'
  ).then(function () {
    Vue.prototype.$auth.logout();
  });
}
/**
 * 测试环境浏览器禁用了非安全域的 navigator.clipboard 对象调整为第二种写法
// function copyText (val) {
//   navigator.clipboard.writeText(val).then(() => {
//     rt.showSuccessToast('已复制到剪贴板！', false);
//   });
// }

/**
 * 复制单行内容到粘贴板
 * content : 需要复制的内容
 * message : 复制完后的提示，不传则默认提示"已复制到剪贴板！"
 */
function copyText (content, message) {
  var aux = document.createElement('input');
  aux.setAttribute('value', content);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand('copy');
  document.body.removeChild(aux);
  if (message === undefined) {
    rt.showSuccessToast(`${content}\xa0 复制成功`, true);
  } else {
    rt.showSuccessToast(`${content}\xa0 ${message}`, true);
  }
}

function refreshParentPage () {
  if (window.top != null && window.top.opener != null) {
    window.top.opener.location.reload();
  }
}

function showFullWindow (url) {
  var width = screen.width;
  var height = screen.height;
  return showWindow(url, {
    width: width,
    height: height
  });
}

function showLargeWindow (url) {
  return showWindow(url, {
    width: 1024,
    height: 768
  });
}

function showSmallWindow (url) {
  return showWindow(url, {
    width: 400,
    height: 300
  });
}

function refresh () {
  Vue.prototype.$router.go(0);
}

function isNull (arg) {
  return arg === null;
}

function showWindow (url, config) {
  if (isNull(config)) {
    config = {};
  }

  if (isNull(config.width) || config.width === 0) {
    config.width = 800;
  }

  if (isNull(config.height) || config.height === 0) {
    config.height = 600;
  }

  var WINDOWS_TASK_BAR_HEIGHT = 40; // 任务栏的高度
  var winTop = Math.round(
    (screen.height - config.height - WINDOWS_TASK_BAR_HEIGHT) * 0.5
  );
  var winLeft = Math.round((screen.width - config.width) * 0.5);

  var strFeatures =
    'help=no,maximize=no,minimize=no,menubar=no,toolbar=no,status=no,location=no,resizable=no' +
    ',width=' +
    config.width +
    ',height=' +
    config.height +
    ',top=' +
    winTop +
    ',left=' +
    winLeft;

  window.open(url, '_blank', strFeatures);
}

function delay (action, delayMilliseconds) {
  if (!this.isFunction(action)) {
    throw new Error('第一个参数必须是function对象.');
  }

  if (this.isNull(delayMilliseconds)) {
    delayMilliseconds = 2 * 1000;
  }

  setTimeout(action, delayMilliseconds);
}

function getScreenHeight () {
  return document.documentElement.clientHeight || document.body.clientHeight;
}
function getScreenWidth () {
  return document.documentElement.clientWidth || document.body.clientWidth;
}

const getDefaultLocalid = () => {
  const { defaultLocaleId, defaultLocaleIdStorageKey } = xpcConfig.get();
  return localStorage[defaultLocaleIdStorageKey] || defaultLocaleId || '2052';
};

const getDefaultLocal = () => {
  const { defaultLocale, defaultLocaleStorageKey } = xpcConfig.get();
  return localStorage[defaultLocaleStorageKey] || defaultLocale || 'zh-CN';
};

const getLocales = () => {
  return new Promise((resolve, reject) => {
    rt.get('api/PortalLanguage/GetLanguageList')
      .then(res => {
        resolve(
          res.map(item => {
            return {
              value: item.new_code,
              name: item.new_displayname,
              native: item.new_name,
              langid: item.new_langid
            };
          })
        );
      })
      .catch(() => {
        reject(new Error('get locales error'));
      });
  });
};

const getMessages = () => {
  return new Promise((resolve, reject) => {
    const defaultlocaleid = getDefaultLocalid();
    rt.get(`api/PortalLanguage/GetLanguageConfigs?langId=${defaultlocaleid}`)
      .then(res => {
        resolve(res);
      })
      .catch(() => {
        reject(new Error('get messages error'));
      });
  });
};

function setLangConfigs (i18n) {
  let locales = getLocales();
  locales.then(res => {
    localStorage.setItem('locales', res);
  });

  let messages = getMessages();
  messages.then(res => {
    const locale = getDefaultLocal();
    i18n.locale = locale;
    i18n.setLocaleMessage(locale, res);

    Vue.http.interceptors.request.use(function (config) {
      config.headers['Accept-Language'] = locale;
      return config;
    });
  });
}

function autoColumnWidth (column, vm) {
  if (column.type !== 'object') return;
  const className = `.rt-fixed-column-${column.prop} .cell`;
  vm.$nextTick(() => {
    const els = document.querySelectorAll(className);
    const widthArry = Array.from(els).map(el => {
      const spans = Array.from(el.querySelectorAll('span.computer-span'));
      let sum = 0;
      if (spans.length) {
        spans.forEach(item => {
          sum += item.offsetWidth === 0 ? 4 : item.offsetWidth * 1.1;
        });
      }
      return sum;
    });
    const computedWidth = Math.max(...widthArry, column.originWidth);
    // eslint-disable-next-line no-param-reassign
    column.width = computedWidth;
  });
}

function parseAddress (text) {
  return new Promise((resolve, reject) => {
    const result = Parse.parse(text);
    if (result.length === 1) {
      const { code, province, city, area, details, name, mobile, phone } = result[0];
      const data = {
        code,
        name,
        province,
        city,
        country: area,
        address: details,
        phone: phone || mobile
      }
      resolve(data);
    } else {
      reject(new Error('Parse error!'));
    }
  });
}

export {
  goBack,
  copyText,
  logout,
  refreshParentPage,
  showFullWindow,
  showLargeWindow,
  showSmallWindow,
  refresh,
  showWindow,
  delay,
  getScreenHeight,
  getScreenWidth,
  getDefaultLocal,
  getDefaultLocalid,
  getLocales,
  getMessages,
  setLangConfigs,
  autoColumnWidth,
  parseAddress
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/libs/util.js